/* eslint-disable */

import React from "react";

function Header() {
  return (
    <header className="header">
      <h1>Is Your Birthday Lucky? 🎂 🤔</h1>
    </header>
  );
}
export default Header;
